import { useEffect } from "react";
import Loader from "../../components/atoms/Loader";
import {
  OutletContextProps,
  WithRouterProps,
} from "../../helpers/RouterHelper";
import { AuthenticateRouterProps } from "../../hocs/enhanceAuthenticatedPage";
import enhanceStudentsPage from "../../hocs/enhanceStudentsPage";
import { useFetchKarte } from "../../hooks/http/useFetchKarte";
import { useQueryError } from "../../hooks/http/useQueryError";
import StudentInterface from "../../interfaces/StudentInterface";
import StudentKarteEdit from "./StudentsKarteEdit";

interface Props
  extends WithRouterProps<AuthenticateRouterProps & { karteId: string }>,
    OutletContextProps {
  student: StudentInterface;
}

const StudentsKarteEditPage = (props: Props) => {
  const { student, params, setActiveMenu } = props;

  const {
    data: karteData,
    isPending,
    error,
  } = useFetchKarte({
    studentId: params.studentId,
    karteId: params.karteId,
  });
  useQueryError(error);

  useEffect(() => {
    setActiveMenu("karte");
  }, []);

  if (isPending || !karteData) {
    return <Loader loading />;
  }

  return <StudentKarteEdit student={student} karte={karteData} />;
};

export default enhanceStudentsPage(StudentsKarteEditPage, {
  title: "カルテ編集",
});
